var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3409_3540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7161 31.003C10.5019 30.9999 5.46625 26.9673 5.46869 21.996C5.47114 17.0246 10.5107 12.9969 16.725 13C22.9392 13.0031 27.9749 17.0356 27.9724 22.007C27.9709 25.041 26.0933 27.7235 23.2176 29.3528L23.9049 32.744L19.4434 30.7381C18.5701 30.9116 17.6566 31.0034 16.7161 31.003Z",
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.998,
    y1: 20.2441,
    x2: 19.998,
    y2: 20.2441,
    stroke: "#255986"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.998,
    y1: 24.2441,
    x2: 19.998,
    y2: 24.2441,
    stroke: "#255986"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3475 27.5495C45.8215 27.5453 52.6883 22.0464 52.6849 15.2672C52.6816 8.48805 45.8094 2.99584 37.3355 3C28.8615 3.00417 21.9947 8.50314 21.998 15.2823C22.0001 19.4199 24.5609 23.0782 28.483 25.2999L27.5459 29.9236L33.6294 27.1885C34.8199 27.4249 36.0654 27.5501 37.3475 27.5495Z",
    fill: "#255986"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1528,
    y1: 15.79,
    x2: 45.5192,
    y2: 15.79,
    stroke: "#64C1B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1528,
    y1: 11.6987,
    x2: 45.5192,
    y2: 11.6987,
    stroke: "#64C1B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1528,
    y1: 19.8818,
    x2: 41.4276,
    y2: 19.8818,
    stroke: "#64C1B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3409_3540",
    x: 0.46875,
    y: 0,
    width: 57.2163,
    height: 39.7441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.34902 0 0 0 0 0.52549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3409_3540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3409_3540",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaries);
export default __webpack_public_path__ + "static/media/questionnaries.31a0c5038b88d91a53c6f4c2b030a8cd.svg";
export { ForwardRef as ReactComponent };